import type { TextProps } from 'recharts';

import styles from './styles/BarChart.module.scss';

interface XAxisTickProps extends Partial<TextProps> {
  payload?: {
    coordinate: number;
    index: number;
    offset: number;
    value: string;
  };
  x?: number;
  y?: number;
}

export const XAxisTick = ({ payload, x, y }: XAxisTickProps) => {
  if (!payload) return null;
  return (
    <g transform={`translate(${x},${y})`}>
      <text className={styles.xAxisLabel} dy={4} style={{ fontSize: '12px' }} textAnchor="end" x={0} y={0}>
        {payload.value}
      </text>
    </g>
  );
};
